module.exports = __webpack_public_path__ + "static/media/pellegrino.4a514723.glb";